import {AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';

import {Subscription} from 'rxjs';

import {Annotation} from '4d-mapper'
import {APITypes, AppConstants} from '../../../../../commons/global';


import { PinViewer } from '../pin.component';

const Cesium = (<any>window).Cesium

export class Attribute {
  key: string;
  value: string;
}

@Component({
  selector: 'pin-comp',
  templateUrl: '../pin.component.html',
  styleUrls: ['../../../map_commons.scss','../pin.component.scss']
})
export class DatumViewer extends PinViewer{

  searchDatumAssetId(assetId: string, annotation: Annotation) {

    this.mapService.fourD.V.api('/remote/' + this.mapService.fourD.getApi(APITypes.Datum360.NAME).id + '/objects/TAGGED_ITEM/id/' + assetId)
      .subscribe(
        succ => {
          if (succ.error) {
            this.openSnackBarError(succ.error)
          }
          else {
            succ.asset_id = succ.id
            delete succ.id
            succ.attrs = Object.keys(succ.attrs).map(a => succ.attrs[a]).filter(a => a.value && a.value != '')
            annotation[AppConstants.DATAUM_ASSET] = succ
            annotation.uid = succ.hdl
            annotation.name = succ.asset_id

            var coords = annotation.cartographic()

            var href = window.location.href
            href = href.substring(0, href.indexOf('/search')) + '/search/' + annotation.uid
            this.mapService.fourD.V.api('/remote/' + this.mapService.fourD.getApi(APITypes.Datum360.NAME).id + '/write', 'post',
              {
                tag: assetId,
                class: succ['clsname'],
                asset: succ['facility'],
                coords: 'lat:' + coords.latitude + ' long:' + coords.longitude + ' height:' + coords.height,
                href: href
              }).subscribe()

            this.mapService.fourD.V.searchByObject(Annotation)
              .equals('project', this.mapService.currentProject.id)
              .equals('active', true)
              .equals('name', annotation.name)
              .notEquals('id', annotation.id)
              .queryObservable()
              .subscribe(s => {
                if(s.items.length > 0){
                  this.openSnackBarError('MAP.DRAWING_EXIST');
                }else{
                  annotation.saveObservable().subscribe(succ => {
                    this.openSnackBarSuccess('API.' + APITypes.Datum360.NAME + '.ASSET_FOUND')

                  })
                }
              })
          }

        }, err => {
          //this.openSnackBarError("API." +  APITypes.Datum360.NAME + ".ASSET_NOT_FOUND")
          console.log('Enter after searching datum')
        })
  }

}
